import React, { useState } from 'react';
import { useAppSelector } from '../../../../infra/hooks';
import ActiveAssetsPresenter from './ActiveAssetsPresenter';
import DTOActiveAssets from './DTOActiveAssets';
import { useTranslation } from 'react-i18next';

function ActiveAssetsController() {
  const [allactiveassetData, setAllactiveassetData] = useState([]);
  const { t } = useTranslation();

  const isLoading = useAppSelector(
    (state) => state.activeAssetsSlice.activeAssetsLoader,
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function callBackFunc(data: any) {
    setAllactiveassetData(data);
  }

  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <>
      <DTOActiveAssets setassignedassetData={callBackFunc} />
      <ActiveAssetsPresenter
        activeassetData={allactiveassetData}
        isLoading={isLoading}
        hr_view={hr_view}
        trans={t}
      />
    </>
  );
}
export default ActiveAssetsController;
